<template>
    <div class="md-layout text-center login_biz">
      <div
        class=" md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <h1 slot="title" class="title login-title bg-transparent">Confirm Account</h1>
      </div>
      <div
        class="md-layout-item md-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix"
      >>
        <login-card>
            <div class="logoWpr" slot="title"><img src="/img/logo-sm.png" alt="Bizminer small logo"></div>
            <h1 slot="title" class="title login-title">Confirm your account</h1>
            <p slot="title" class="sub_title">We have sent a confirmation email. Please activate your new account via the email received.</p>
        </login-card>
      </div>
    </div>
  </template>
  
  <script>
  import { LoginCard } from "@/components";
  
  export default {
  components: {
    LoginCard,
  },
  };
  </script>
  <style scoped>
  </style>
  